import { NavigateFunction } from "react-router-dom";
import { paths } from "@admin/routes/paths";
import { appConstants } from "@admin/constants/app-constants";


/**
 * Navigates to the login page, optionally including a return path
 *
 * @param navigate - React Router navigate function
 * @param returnPath - Optional path to return to after login (defaults to current path)
 * @param skipReturnPath - If true, doesn't include a return path (used for logout)
 */

export const navigateToLogin = (
	navigate: NavigateFunction,
	returnPath?: string,
	skipReturnPath = false
): void => {
	// For logout or when explicitly skipping return path
	if (skipReturnPath) {
		navigate(paths.auth.root);
		return;
	}

	// If no return path is provided, use the current location
	// This needs to be called where we have access to location object
	// Otherwise, returnPath must be explicitly provided
	if (returnPath) {
		// Encode the return path to handle special characters
		const encodedReturnPath = encodeURIComponent(returnPath);
		navigate(`${paths.auth.root}?${appConstants.redirectQueryParamName}=${encodedReturnPath}`);
	} else {
		// If no return path provided and not skipping, just go to login
		// This is a fallback - ideally returnPath should be provided
		navigate(paths.auth.root);
	}
};

/**
 * Extracts the return path from URL search params
 *
 * @param search - URL search string
 * @returns The decoded return path or dashboard path if none found
 */
export const getReturnPath = (search: string): string => {
	const params = new URLSearchParams(search);
	const returnPath = params.get(appConstants.redirectQueryParamName);

	if (returnPath) {
		return decodeURIComponent(returnPath);
	}

	return paths.dashboard.root;
};
